const APIS = {
  /*  INFO: Website builder endppoints */
  THEME_SETTING: "/websitebuilderservice/api/theme-setting/",
  FOOTER: "/websitebuilderservice/api/footer/",
  HEADER: "/websitebuilderservice/api/header/",
  POPUP: "/websitebuilderservice/api/popup/",
  PAGE: "/websitebuilderservice/api/page/",
  META_TAG: "/metatagservice/api/meta-tag/",
  BRANCH: "/logisticservice/api/branch/",
  NAVIGATION: "/websitebuilderservice/api/navigation/",
  // MEDIA: "/websitebuilderservice/api/media/",
  COMPONENT: "/websitebuilderservice/api/component/",
  FILE: "/driveservice/api/file/",
  PRODUCT: "/productservice/api/product/",
  FORMS: "/formbuilderservice/api/dynamic-form/",
  COLLECTION: "/productservice/api/category/",
  CATEGORY: "/productservice/api/category/",
  BLOG: "/blogservice/api/blog/",
  AUTHOR: "/blogservice/api/author/",
  BLOG_CATEGORY: "/blogservice/api/category/",
  LOCATION: "/productservice/api/location/",
  TAG: "/blogservice/api/tag/",
};

export default APIS;
